module.exports = __webpack_public_path__ + "img/tb-minion.b01c557e.png";